import { render, staticRenderFns } from "./body-attribute-recognition.vue?vue&type=template&id=5a6ef88f&scoped=true&"
import script from "./body-attribute-recognition.vue?vue&type=script&lang=ts&"
export * from "./body-attribute-recognition.vue?vue&type=script&lang=ts&"
import style0 from "./body-attribute-recognition.vue?vue&type=style&index=0&id=5a6ef88f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6ef88f",
  null
  
)

export default component.exports